<template>
  <div class="set">
    <el-tabs
      v-model="active"
      class="demo-tabs set-nav"
      @tab-change="handleSelect"
    >
      <el-tab-pane label="关于本机" name="AboutNew"></el-tab-pane>
      <el-tab-pane label="网络设置" name="adminSetSystemNet"></el-tab-pane>
    </el-tabs>

    <div class="set-con">
      <AboutNew v-if="active == 'AboutNew'" />
      <adminSetSystemNet v-if="active == 'adminSetSystemNet'"/>
    </div>
  </div>
</template>

<script>
import AboutNew from "@/views/aboutNew/index.vue";
import adminSetSystemNet from "@/views/adminSet/net/index.vue";
export default {
  name: "Page",
  components: { adminSetSystemNet, AboutNew },
  data() {
    return {
      active: this.$route.query.active || "AboutNew",
    };
  },
  mounted() {},
  methods: {
    handleSelect(name) {
      this.active = name;
    },
  },
};
</script>
<style scoped lang="less" src="./index.less"></style>
